import React from 'react';
import './Logo.css';

const Logo = ({ className = '' }) => {
  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <img 
      src="/images/logo-header.png"
      alt="Innexia Logo"
      className={`innexia-logo ${className}`}
      onClick={handleLogoClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleLogoClick();
        }
      }}
      tabIndex={0}
      role="button"
      aria-label="Ir al inicio"
    />
  );
};

export default Logo;

